module.exports = __webpack_public_path__ + "static/media/headerLogo.464b42c2.png";